var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnNternow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 23,
    viewBox: "0 0 50 46",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FB5700",
    fillRule: "evenodd",
    d: "m45.354 18.776-9.822-1.835-9.273 12.728-5.613 7.975L7.94 30.843v4.421l18.157 10.4 5.038-2.87.024-11.6 5.92-7.984V39.41l8.32-4.738-.044-15.897Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBC99",
    d: "M34.311 10.362 15.1 0l15.479 2.599L49.79 12.96 34.31 10.362Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FED7C2",
    d: "m34.313 10.361 15.478 2.599-1.108 2.582-14.19-2.557-14.043 19.24-1.184-1.249 15.047-20.615Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBC99",
    d: "M20.45 32.224 1.236 21.856.053 20.608l19.212 10.368 1.184 1.248Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5700",
    d: "M19.264 30.98.052 20.61 15.1.003l19.21 10.361L19.264 30.98Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h194v46H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNternow);
export default __webpack_public_path__ + "static/media/icn-nternow.3c0b73af163b3e75584b81b946356092.svg";
export { ForwardRef as ReactComponent };